/**
 * Trust-state resolution for the Designer brief.
 *
 * A single escalating ladder describes how much to trust the product info the
 * designer is looking at. Precedence (highest trust first):
 *   1. REVIEWED   — a human ticked the intake "Reviewed" toggle (accuracy_reviewed).
 *   2. AI MATCH   — not reviewed, but the order's code resolved to a catalog product.
 *   3. AI EXTRACT — not reviewed and no catalog match; only the raw extraction exists.
 *
 * REVIEWED is green ("a person confirmed this"); AI MATCH / AI EXTRACT are amber
 * ("machine output — check it against the source document on the left"). This is
 * the single source of truth for both the badge over the matched photo and the
 * badge on the recipe card, so they can never disagree.
 */
export const TRUST_REVIEWED = 'reviewed';
export const TRUST_AI_MATCH = 'ai_match';
export const TRUST_AI_EXTRACT = 'ai_extract';

/**
 * @param {object} order            the order record (reads accuracy_reviewed)
 * @param {object|null} resolvedProduct  response from /orders/{id}/resolve-product
 * @returns {{key: string, label: string, tone: 'green'|'amber'}}
 */
export function resolveTrustState(order, resolvedProduct) {
  if (order && order.accuracy_reviewed) {
    return { key: TRUST_REVIEWED, label: 'REVIEWED', tone: 'green' };
  }
  if (resolvedProduct && resolvedProduct.resolved) {
    return { key: TRUST_AI_MATCH, label: 'AI MATCH', tone: 'amber' };
  }
  return { key: TRUST_AI_EXTRACT, label: 'AI EXTRACT', tone: 'amber' };
}
